import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from 'teamProfiles/styles/EditDetails.style';

export default function EditableNicknameInput({
  isCreateMode,
  onSave,
  onCancel,
}: {
  isCreateMode: boolean;
  onSave: (value: string) => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation('pageTeam');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSave(inputRef.current?.value || '');
    } else if (e.key === 'Escape') {
      e.preventDefault();
      onCancel();
    }
  };

  const handleBlur = () => {
    // Save on blur if there's a value, otherwise cancel
    if (inputRef.current?.value?.trim()) {
      onSave(inputRef.current?.value || '');
    } else {
      onCancel();
    }
  };

  return (
    <Styled.EditableNicknameTag>
      <Styled.EditableNicknameInput
        ref={inputRef}
        type="text"
        placeholder={t(
          isCreateMode
            ? 'addProfile.writeNickname'
            : 'editDetails.writeNickname'
        )}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
      />
    </Styled.EditableNicknameTag>
  );
}
